import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import {isPlatformBrowser} from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class PlatformService {

  constructor(
    @Inject(PLATFORM_ID) private platformId: any,
  ) { }

  isBrowser(): boolean {
    return isPlatformBrowser(this.platformId);
  }

  localStorageSet(key: string, value: string): boolean {
    if (this.isBrowser()) {
      localStorage.setItem(key, value);
      return true;
    }
    return false;
  }

  localStorageGet(key: string): string {
    if (this.isBrowser()) {
      return localStorage.getItem(key);
    }
    return null;
  }

  localStorageRemove(key: string): boolean {
    if (this.isBrowser()) {
      localStorage.removeItem(key);
      return true;
    }
    return false;
  }
}
